import React, { useEffect, useState, useRef } from 'react';
import './input.scss';
import style from './index.module.scss'
import send from './send.png';
import { message } from 'antd';

import Tribute from "tributejs";
import { Button } from 'antd';
interface Props {
  onSend?: any;
  ref?: any;
}
const htmlEscape = (html: string) => {
  return html.replace(/[<>"&]/g, function (match, pos, originalText) {
    switch (match) {
      case "<":
        return "&lt;";
      case ">":
        return "&gt;"
      case "&":
        return "&amp;";
      case "\"":
        return "&quot;";
      default:
        return match;
    }
  });
}

const AtInput = (props: Props, ref: any) => {
  const [atList, setAtList] = useState([
    {
      key: "知识库",
      value: "知识库",
      position: "知识库"
    },
    // {
    //   key: "2",
    //   value: "小李",
    //   position: "后端开发工程师"
    // }
  ]);
  const [poundList, setpoundList] = useState([
    { name: "JavaScript", explain: "前端开发语言" },
    { name: "Java", explain: "后端开发语言之一" }
  ]);
  const [content, setcontent] = useState<string>('');

  useEffect(() => {
    renderEditor(atList, poundList);
  }, [])

  const renderEditor = (_atList: any[], _poundList: any[]) => {
    let tributeMultipleTriggers = new Tribute({
      allowSpaces: true,
      noMatchTemplate: function () { return ''; },
      collection: [
        {
          selectTemplate: function (item) {
            // if (this.range.isContentEditable(this.current.element)) {
            //   return (
            //     `<span contenteditable="false">
            //       <span
            //         class="at-item"
            //         title="${item.original.value}"
            //         data-atkey="${item.original.key}"
            //         data-atvalue="${item.original.value}"
            //       >
            //         @${item.original.value}
            //       </span>
            //     </span>`
            //   );
            // }

            return "@" + item.original?.value;
          },
          values: _atList,
          menuItemTemplate: function (item) {
            return item.original.value;
          },
        },
        {
          trigger: "#",
          selectTemplate: function (item) {
            // if (this.range.isContentEditable(this.current.element)) {
            //   return (
            //     `<span contenteditable="false">
            //       <span
            //         class="pound-item"
            //         data-poundname="${item.original.name}"
            //       >
            //         #${item.original.name}
            //       </span>
            //     </span>`
            //   );
            // }

            return "#" + item.original.name;
          },
          values: _poundList,
          lookup: "name",
          fillAttr: "name"
        }
      ]
    });

    tributeMultipleTriggers.attach(document.getElementById("editorMultiple") as HTMLElement);
  }

  const getDataOfEditorMultiple = () => {
    console.log('content11', content)
    const childrenData = document.getElementById('editorMultiple')?.innerHTML || '';
    console.log('childrenData', childrenData)
    // const toServiceData = htmlEscape(childrenData);
    const toServiceData = content;
    console.log('toServiceData', toServiceData)
    if (!toServiceData) {
      message.error('请输入内容');
      return;
    }
    props.onSend && props.onSend(toServiceData);
    setcontent('')
    // (document as any).getElementById('editorMultiple').innerHTML = ''
  }

  const onInput = () => {
    const atItemList = document.getElementsByClassName('at-item');
    Array.prototype.forEach.call(atItemList, function (el) {
      console.log(el.dataset.atkey);
      console.log(el.dataset.atvalue);
    });
  }
  const onChange = (e: any) => {
    console.log('onChange', e)
  }
  return (
    <div className={style.msginput}>
      {/* <div
        id="editorMultiple"
        className={style.input}
        placeholder="发表评论"
        onInput={onInput}
        onChange={onChange}
      ></div> */}
      <textarea
        value={content}
        id="editorMultiple"
        className={style.input}
        placeholder={'发表评论'}
        onChange={(e) => {
          setcontent(e.target.value)
        }} />
      {/* <Button onClick={getDataOfEditorMultiple}>获取输入框中所有元素</Button> */}
      <div
        className={style.icon}
        onClick={getDataOfEditorMultiple}>
        <img src={send} />
        {/* <SendOutlined /> */}
      </div>
    </div >
  )
}

export default AtInput;